import React from "react";
import { Accordion, Card, Col } from "react-bootstrap";
import { IoMdCheckmark } from "react-icons/io";

import { employeeDropdownLabel, formatDDMMYYYYbyYYYYMMDD, userDropdownLabel } from "app/_helpers/helper";
import { Row } from "react-bootstrap";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";
import CustomPopover from "app/Components/CommanComponents/CustomPopover";
import { BsFillInfoCircleFill } from "react-icons/bs";
import { isArray } from "lodash";
import { MEETING_STATUS, OHSE_ROLE_LIST_VIEW } from "../CONSTANT";
// import { VFL_STATUS } from "../CONSTANTS";

const MeetingTimeline = ({ form }) => {
  const plannedFlag = form?.date ? true : false;
  const scheduledFlag = form?.approvedDate ? true : false;
  const reviewFlag = form?.reviewedDate ? true : false;
  const progressFlag = form?.isProgress ? true : false;
  const executedFlag = form?.isExecuted ? true : false;
  const meetingFlag = form?.closeDate ? true : false;
  return (
    <div className="card p-3  pb-0 mt-4">
      <Row>
        <Col lg={12}>
          <Accordion defaultActiveKey="1" className="timeline">
            <div
              className={`timelineSection ${plannedFlag
                ? "completedtimelineSection"
                : "pendingtimelineSection"
                }`}
            >
              <Accordion.Toggle as={Card.Header} eventKey={plannedFlag ? "1" : '0'}>
                <div
                  className={`number ${plannedFlag ? "completednumber" : "notstrtednumber"
                    }`}
                >
                  {plannedFlag ? <IoMdCheckmark /> : 1}
                </div>
                <h4>Planned</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="1">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Request Date</h5>
                        <h5>
                          {DDMMYYYYFormat(form?.date)}
                        </h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Planned By</h5>
                        <h5>
                          {OHSE_ROLE_LIST_VIEW[form?.scheduler]}
                        </h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Name</h5>
                        <h5>
                          {userDropdownLabel(form?.schedularData)}
                        </h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>
            <div
              className={`timelineSection ${scheduledFlag
                ? "completedtimelineSection"
                : "pendingtimelineSection"
                }`}
            >
              <Accordion.Toggle as={Card.Header} eventKey={scheduledFlag ? "2" : '0'}>
                <div
                  className={`number ${scheduledFlag ? "completednumber" : "notstrtednumber"
                    }`}
                >
                  {scheduledFlag ? <IoMdCheckmark /> : 2}
                </div>
                <h4>Scheduled</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="2">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Approval Date</h5>
                        <h5>
                          {formatDDMMYYYYbyYYYYMMDD(form?.approvedDate)}
                        </h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Approved By</h5>
                        <h5>
                          {OHSE_ROLE_LIST_VIEW[form?.approver]}
                        </h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Name</h5>
                        <h5>
                          {userDropdownLabel(form?.approverData)}
                        </h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>

            <div
              className={`timelineSection ${progressFlag
                ? "completedtimelineSection"
                : "pendingtimelineSection"
                }`}
            >
              <Accordion.Toggle as={Card.Header} eventKey={progressFlag ? "3" : '0'}>
                <div
                  className={`number ${progressFlag ? "completednumber" : "notstrtednumber"
                    }`}
                >
                  {progressFlag ? <IoMdCheckmark /> : 3}
                </div>
                <h4>In-Progress</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="3">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Date</h5>
                        <h5>
                          {formatDDMMYYYYbyYYYYMMDD(form?.inProgressDate)}
                        </h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Name</h5>
                        <h5>
                          {userDropdownLabel(form?.inProgressedByData)}
                        </h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>

            {form?.reviewer ? (
              <div
                className={`timelineSection ${reviewFlag
                  ? "completedtimelineSection"
                  : "pendingtimelineSection"
                  }`}
              >
                <Accordion.Toggle as={Card.Header} eventKey={reviewFlag ? "4" : '0'}>
                  <div
                    className={`number ${reviewFlag ? "completednumber" : "notstrtednumber"
                      }`}
                  >
                    {reviewFlag ? <IoMdCheckmark /> : 4}
                  </div>
                  <h4>Reviewed</h4>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey="4">
                  <div className="px-4 pt-0 timelineText">
                    <ul className="list-inline d-flex">
                      <li>
                        <div className="timelineRow">
                          <h5 className="txtgrey">Review Date</h5>
                          <h5>
                            {formatDDMMYYYYbyYYYYMMDD(form?.reviewedDate)}
                          </h5>
                        </div>
                        <div className="timelineRow">
                          <h5 className="txtgrey">Reviewed By</h5>
                          <h5>
                            {OHSE_ROLE_LIST_VIEW[form?.reviewerRole]}
                          </h5>
                        </div>
                        <div className="timelineRow">
                          <h5 className="txtgrey">Name</h5>
                          <h5>
                            {userDropdownLabel(form?.reviewerData)}
                          </h5>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Accordion.Collapse>
              </div>
            ) : ''}

            <div
              className={`timelineSection ${executedFlag
                ? "completedtimelineSection"
                : "pendingtimelineSection"
                }`}
            >
              <Accordion.Toggle as={Card.Header} eventKey={executedFlag ? "5" : '0'}>
                <div
                  className={`number ${executedFlag ? "completednumber" : "notstrtednumber"
                    }`}
                >
                  {executedFlag ? <IoMdCheckmark /> : form?.reviewer ? 5 : 4}
                </div>
                <h4>Executed</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="5">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Meeting Date</h5>
                        <h5>
                          {DDMMYYYYFormat(form?.executionDate)}
                        </h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Total Participants</h5>
                        <h5>
                          {form?.participants?.length}
                        </h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>

            {((form?.eventStatus === MEETING_STATUS.closed && meetingFlag) || form?.eventStatus !== MEETING_STATUS.closed) && (
              <div
                className={`timelineSection ${meetingFlag
                  ? "completedtimelineSection"
                  : "pendingtimelineSection"
                  }`}
              >
                <Accordion.Toggle as={Card.Header} eventKey={meetingFlag ? "6" : '0'}>
                  <div
                    className={`number ${meetingFlag ? "completednumber" : "notstrtednumber"
                      }`}
                  >
                    {meetingFlag ? <IoMdCheckmark /> : form?.reviewer ? 6 : 5}
                  </div>
                  <h4>Meeting Tasks</h4>
                </Accordion.Toggle>

                <Accordion.Collapse eventKey="6">
                  <div className="px-4 pt-0 timelineText">
                    <ul className="list-inline d-flex">
                      <li>
                        <div className="timelineRow">
                          <h5 className="txtgrey">Completion Date</h5>
                          <h5>
                            {formatDDMMYYYYbyYYYYMMDD(form?.closeDate)}
                          </h5>
                        </div>
                        <div className="timelineRow">
                          <h5 className="txtgrey">Total Tasks&nbsp;
                            <CustomPopover
                              placement={"right"}
                              tooltip={
                                <>
                                  <table className="table table-bordered tooltipTable">
                                    <thead>
                                      <tr>
                                        <th>Task ID</th>
                                        <th>Owner</th>
                                        <th>Completion Date</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {isArray(form?.tasks) &&
                                        form?.tasks.map((obj) => {
                                          return obj?.taskOwners.map((data) => {
                                            return (
                                              <tr>
                                                <td>{obj.id}</td>
                                                <td>
                                                  {userDropdownLabel(data?.userData)}
                                                </td>
                                                <td>{formatDDMMYYYYbyYYYYMMDD(obj.completionDate)}</td>
                                              </tr>
                                            );
                                          });
                                        })
                                      }
                                    </tbody>
                                  </table>
                                </>
                              }
                            >
                              <BsFillInfoCircleFill />
                            </CustomPopover></h5>
                        </div>
                      </li>
                    </ul>
                  </div>
                </Accordion.Collapse>
              </div>
            )}

            <div
              className={`timelineSection ${meetingFlag || form?.eventStatus === MEETING_STATUS.closed
                ? "completedtimelineSection"
                : "pendingtimelineSection"
                } lastTimeLine`}
            >
              <Accordion.Toggle as={Card.Header} eventKey={meetingFlag || form?.eventStatus === MEETING_STATUS.closed ? "7" : '0'}>
                <div
                  className={`number ${meetingFlag || form?.eventStatus === MEETING_STATUS.closed ? "completednumber" : "notstrtednumber"
                    }`}
                >
                  {meetingFlag || form?.eventStatus === MEETING_STATUS.closed ? <IoMdCheckmark /> : form?.reviewer ? 7 : 6}
                </div>
                <h4>Completed</h4>
              </Accordion.Toggle>

              <Accordion.Collapse eventKey="7">
                <div className="px-4 pt-0 timelineText">
                  <ul className="list-inline d-flex">
                    <li>
                      <div className="timelineRow">
                        <h5 className="txtgrey">MOM Approval Date</h5>
                        <h5>
                          {DDMMYYYYFormat(
                            form?.executionDate
                          )}
                        </h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Approved By </h5>
                        <h5>
                          {OHSE_ROLE_LIST_VIEW[form?.approver]}
                        </h5>
                      </div>
                      <div className="timelineRow">
                        <h5 className="txtgrey">Approver Name </h5>
                        <h5>
                          {userDropdownLabel(form?.approverData)}
                        </h5>
                      </div>
                    </li>
                  </ul>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </Col>
      </Row>
    </div>
  );
};

export default MeetingTimeline;
